import { Card } from '@opositandopn/ui';
import classnames from 'classnames';

import { SectionCardProps } from './SectionCard.types';

import styles from './SectionCard.module.scss';

function SectionCard({
  className,
  title,
  children,
  loading,
  image,
  button,
  icon,
  tooltip,
}: SectionCardProps) {
  return (
    <Card
      title={title}
      className={classnames(styles['main'], {
        [styles['main--image']]: image,
      })}
      loading={loading}
      icon={icon}
      tooltip={tooltip}
    >
      <div className={styles['section']}>
        {children && (
          <div className={classnames(styles['section-content'], className)}>
            {children}
          </div>
        )}
        {image && (
          <div className={styles['image-wrapper']} aria-hidden="true">
            <img className={styles['image']} src={image} alt="" />
          </div>
        )}
        {button && <div className={styles['section-button']}>{button}</div>}
      </div>
    </Card>
  );
}

export { SectionCard };
